<template>
  <div class="container my-5">
    <div class="card shadow-sm border-0">
      <div class="card-body">
        <h3 class="mb-3">📊 {{ t('tuik.source_title') }}</h3>
        <p v-html="t('tuik.source_description')"></p>

        <h5 class="mt-4">{{ t('tuik.legal_title') }}</h5>
        <pre>{{ t('tuik.legal_points') }}</pre>
        <p class="mt-2">
          {{ t('tuik.legal_text') }}
        </p>

        <h5 class="mt-4">ℹ {{ t('tuik.disclaimer_title') }}</h5>
        <p>{{ t('tuik.disclaimer_text') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<style scoped>
.card-body {
  line-height: 1.6;
}
</style>
